export default "__VITE_ASSET__DLtBp87J__"